"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityPeer = void 0;
const model_1 = require("../../../data/model");
const identity_1 = require("../../../data/identity");
const linkup_1 = require("../../../net/linkup");
class IdentityPeer {
    constructor(linkupServer, identityHash, identity) {
        this.linkupServer = linkupServer;
        this.identityHash = identityHash;
        this.identity = identity;
    }
    static fromIdentity(id, linkupServer = linkup_1.LinkupManager.defaultLinkupServer) {
        let ip = new IdentityPeer(linkupServer, id.hash(), id);
        return ip;
    }
    async asPeer() {
        return this.asPeerIfReady();
    }
    asPeerIfReady() {
        if (this.linkupServer === undefined || this.identityHash === undefined) {
            throw new Error('Missing peer information.');
        }
        return { endpoint: new linkup_1.LinkupAddress(this.linkupServer, model_1.Hashing.toHex(this.identityHash)).url(), identityHash: this.identityHash, identity: this.identity };
    }
    async initFromEndpoint(ep, store) {
        const address = linkup_1.LinkupAddress.fromURL(ep);
        this.linkupServer = address.serverURL;
        this.identityHash = model_1.Hashing.fromHex(address.linkupId);
        if (store !== undefined) {
            this.identity = await store.loadRef(new model_1.HashReference(this.identityHash, identity_1.Identity.className));
        }
    }
    static getEndpointParser(store) {
        return async (ep) => {
            const ip = new IdentityPeer();
            await ip.initFromEndpoint(ep, store);
            return ip.asPeer();
        };
    }
}
exports.IdentityPeer = IdentityPeer;
//# sourceMappingURL=IdentityPeer.js.map